import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Partner = () => {
  return (
    <div className="partner-usa p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="partner_content">
                                <h2>Team Up with the Right Prototype Development Company</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                       <p>Partner with TekRevol, a leading Prototype Development Company, for a successful future in modernization. Our expertise transforms your concepts into tangible realities with accuracy, imagination, and guaranteed success. Choose innovation; choose TekRevol to revolutionize your visions into prototypes.</p>
                    </Col>
                </Row>
                <Row className="h-100 partner_padd">
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                    4.9
                    </div>
                    <div className="partner-para">
                        <p>Average Review Rating on Clutch</p>
                    </div>
                </Col> 
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                       5.0
                    </div>
                    <div className="partner-para">
                        <p>Average Review Rating on GoodFirms</p>
                    </div>
                </Col> 
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                         4.8
                    </div>
                    <div className="partner-para">
                        <p>Average Review Rating on RighFirmss </p>
                    </div>
                </Col> 
                </Row>
            </Container>
    </div>
  )
}

export default Partner